{
  "UPLOAD_KEY_REQUIRED": "La clave del archivo es obligatoria.",
  "UPLOAD_KEY_INVALID": "Clave de archivo no válida.",
  "UPLOAD_KEY_FORBIDDEN": "La clave está fuera de las carpetas públicas.",
  "UPLOAD_FILE_REQUIRED": "El archivo es obligatorio.",
  "UPLOAD_PDF_REQUIRED": "El archivo PDF es obligatorio.",
  "UPLOAD_FILE_INVALID": "Archivo no válido. Revisa el tipo y el tamaño del archivo.",
  "MEDIA_LESSON_NOT_FOUND": "Clase no encontrada.",
  "MEDIA_ATTACHMENT_NOT_FOUND": "Adjunto no encontrado.",
  "MEDIA_ATTACHMENT_DELETED": "Adjunto eliminado.",
  "MEDIA_NOT_FOUND": "Archivo multimedia no encontrado.",
  "MEDIA_DELETED": "Archivo multimedia eliminado.",
  "MEDIA_FILE_TYPE_NOT_ALLOWED": "Tipo de archivo no permitido.",
  "MEDIA_FILE_TOO_LARGE": "El archivo es demasiado grande (máx. {{max}}).",
  "MEDIA_VIDEO_TYPE_NOT_ALLOWED": "Tipo de video no permitido.",
  "MEDIA_VIDEO_TOO_LARGE": "El video es demasiado grande (máx. {{max}}).",
  "PAYMENTS_ACCESS_GROUP_REQUIRED": "El grupo de acceso es obligatorio.",
  "PAYMENTS_OFFER_NOT_FOUND": "Oferta no encontrada.",
  "PAYMENTS_PURCHASE_NOT_FOUND": "Compra no encontrada.",
  "PAYMENTS_GATEWAY_NOT_SUPPORTED": "Pasarela de pago no compatible.",
  "PAYMENTS_WEBHOOK_UNAVAILABLE": "Webhook de {{gateway}} no disponible: secreto no configurado.",
  "PAYMENTS_WEBHOOK_SECRET_INVALID": "Secreto del webhook no válido.",
  "GURU_NOT_CONFIGURED": "Guru no está configurado.",
  "GURU_CONNECTION_ESTABLISHED": "¡Conexión con Guru establecida!",
  "GURU_TOKEN_INVALID": "Token no válido o expirado.",
  "GURU_HTTP_ERROR": "Guru devolvió el estado {{status}}.",
  "GURU_CONNECTION_FAILED": "Error al conectar con Guru.",
  "INTEGRATION_NOT_FOUND": "Integración no encontrada.",
  "FREEMIUM_USER_NOT_FOUND": "Usuario no encontrado.",
  "FREEMIUM_ALREADY_AT_TIER": "Ya estás en este plan.",
  "FREEMIUM_CANNOT_DOWNGRADE": "No es posible bajar de plan.",
  "FREEMIUM_UPGRADE_REQUEST_NOT_FOUND": "Solicitud de mejora no encontrada.",
  "FREEMIUM_UPGRADE_ALREADY_PROCESSED": "La solicitud de mejora ya se ha procesado.",
  "FREEMIUM_UPGRADE_FAILED": "No se pudo procesar la mejora de plan.",
  "FREEMIUM_UPGRADE_PAYMENT_REQUIRED": "Solicitud de mejora creada. Se requiere el pago.",
  "FREEMIUM_UPGRADE_PROCESSING": "Solicitud de mejora creada. Procesando...",
  "FREEMIUM_ADMIN_UPGRADE_COMPLETED": "Mejora administrativa completada correctamente.",
  "FREEMIUM_CONTENT_REQUIRES_TIER": "Este contenido requiere el plan {{tier}}.",
  "FREEMIUM_COURSE_LIMIT_REACHED": "Alcanzaste el límite de cursos ({{max}} cursos).",
  "FREEMIUM_LESSON_LIMIT_REACHED": "Alcanzaste el límite mensual de clases ({{max}} clases).",
  "FREEMIUM_DOWNLOADS_NOT_AVAILABLE": "Las descargas no están disponibles en tu plan.",
  "FREEMIUM_CERTIFICATES_NOT_AVAILABLE": "Los certificados no están disponibles en tu plan.",
  "FREEMIUM_AUTH_REQUIRED": "Tienes que iniciar sesión.",
  "FREEMIUM_ACCESS_CHECK_FAILED": "No se pudo verificar tu acceso a este contenido.",
  "DOMAIN_NOT_FOUND": "Dirección no encontrada.",
  "DOMAIN_IN_USE": "Esta dirección ya está en uso.",
  "DOMAIN_NO_VERIFICATION_TOKEN": "Esta dirección no tiene token de verificación.",
  "DOMAIN_PRIMARY_REQUIRES_VERIFIED": "Solo una dirección verificada puede ser la principal.",
  "DOMAIN_PRIMARY_REMOVAL_BLOCKED": "Elige otra dirección como principal antes de eliminar esta.",
  "DOMAIN_INVALID_FORMAT": "Dirección no válida. Usa algo como area.tuescuela.es",
  "DOMAIN_INVALID": "Dirección no válida.",
  "ACCESS_GROUP_NOT_FOUND": "Grupo de acceso no encontrado.",
  "ACCESS_GROUP_HAS_ACTIVE_ENROLLMENTS": "No se puede eliminar el grupo. Hay {{count}} inscripciones activas.",
  "ACCESS_GROUP_DELETED": "Grupo de acceso eliminado correctamente.",
  "ACCESS_GROUP_INTEGRATION_HAS_DEPENDENCIES": "No se puede eliminar: hay compras o enlaces de afiliado vinculados. Desactiva la integración en lugar de eliminarla.",
  "ACCESS_GROUP_INTEGRATION_REMOVED": "Integración eliminada correctamente.",
  "ACCESS_GROUP_NO_PRODUCTS": "El grupo de acceso no tiene productos.",
  "ENROLLMENT_TARGET_REQUIRED": "Indica un producto o un grupo de acceso.",
  "ENROLLMENT_ALREADY_EXISTS": "El usuario ya está inscrito.",
  "ENROLLMENT_NOT_FOUND": "Inscripción no encontrada.",
  "ENROLLMENTS_CREATED": "{{count}} inscripción(es) creada(s) correctamente.",
  "IMPORT_CSV_REQUIRED": "El archivo CSV es obligatorio.",
  "IMPORT_EMAIL_REQUIRED": "El correo electrónico es obligatorio.",
  "IMPORT_USER_NOT_FOUND": "Usuario no encontrado.",
  "WEBHOOK_NOT_FOUND": "Webhook no encontrado.",
  "WEBHOOK_DELETED": "Webhook eliminado correctamente.",
  "WEBHOOK_TEST_SENT": "Webhook de prueba enviado.",
  "FEATURE_NOT_IN_PLAN": "Esta función no está incluida en tu plan. Habla con Xtreed.",
  "FEATURE_UNKNOWN": "Función desconocida: {{features}}",
  "FEATURE_NOT_AVAILABLE": "Esta función no está disponible en esta área de miembros.",
  "TENANT_HOST_REQUIRED": "Debes acceder a esta ruta desde la dirección del área de miembros.",
  "TENANT_SESSION_UNBOUND": "Tu sesión no está vinculada a un área de miembros. Vuelve a iniciar sesión.",
  "TENANT_SESSION_MISMATCH": "Tu sesión no pertenece a esta área de miembros.",
  "ROLES_NOT_AUTHENTICATED": "Usuario no autenticado.",
  "ROLES_INSUFFICIENT_PERMISSION": "No tienes permiso para acceder a este recurso.",
  "SESSION_TOKEN_EXPIRED": "Tu sesión expiró. Vuelve a iniciar sesión.",
  "SESSION_TOKEN_INVALID": "Token no válido.",
  "SESSION_UNAUTHORIZED": "No autorizado."
}
